import { BrandPersonality } from "./types";

export const mockBrandPersonality: BrandPersonality = {
  brand_personality: {
    general_tone: "Moderno e Inspirador",
    principal_values: ["Inclusividade", "Criatividade", "Sustentabilidade"],
  },
  communication_channels_strategies: {
    instagram: "Criar conteúdo visualmente deslumbrante com tutoriais de…",
    facebook: "Compartilhar atualizações sobre lançamentos de produtos…",
    x: "Oferecer dicas rápidas de beleza e maquilhagem, além de retweets…",
    linkedin: "Artigos sobre tendências do setor de beleza e práticas…",
    tik_tok: "Utilizar vídeos criativos para demonstrar transformações…",
  },
  language_style: {
    formality: "Informal",
    writing_style: "Enérgico e Empoderador",
  },
  emotions_to_evoke: {
    principal_emotion: "Autoconfiança",
    secondary_emotion: "Alegria",
  },
  specific_guidelines: {
    formatting_and_text_structure_rules:
      "Utilizar listas e bullet points para tutoriais. Incluir perguntas abertas para incentivar interação e comentários.",
    prohibited_words_or_phrases: ["Perfeito", "Porcelana"],
  },
  hashtags_and_emojis: {
    principal_hashtags: [
      "#MakeBeauty",
      "#BeYou",
      "#GlowWithConfidence",
      "#SustainableBeauty",
    ],
    brand_emojis: ["💄", "🌟", "💖", "🌿", "✨"],
  },
};
